import { render, staticRenderFns } from "./workClothesApplyFor.vue?vue&type=template&id=4e80aa5a"
import script from "./workClothesApplyFor.vue?vue&type=script&lang=js"
export * from "./workClothesApplyFor.vue?vue&type=script&lang=js"
import style0 from "./workClothesApplyFor.vue?vue&type=style&index=0&id=4e80aa5a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports